<template>
    <div>
        <div class="header-container">
            <div class="header-top">
                <h2 class="logo">
                    <i href="javascript:;" title="金榜志愿通" @click="refreshHtml">
                    <img src="../assets/images/logo.jpg" style="width:85%;height:85%;"/>
                    </i>
                </h2>
            <!-- <div class="header-md">
                <el-input v-model="searchContent" placeholder="查大学/查专业/搜问答" style="width:400px;">
                    <el-button slot="append">搜索</el-button>
                </el-input>
            </div> 
            {{gkYear2}}年-->
            <div style="display: block;">
                <div style="font-size:15px;color:#ff9966;font-weight:bold;"
                v-if="isShowGKMsg1">
                距离{{gkYear}}年高考还有 <span style="color:blue;font-size:20px;">{{days}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                "
                v-else-if="isShowGKMsg2">
                距离{{gkYear2}}年高考志愿填报还有 <span style="color:blue;font-size:20px;">{{days2}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                " v-else-if="isShowGKMsg3">
                今天是高考志愿填报第 <span style="color:blue;font-size:20px;">{{days3}} </span>天
                </div>
                <div v-else-if="isShowGKMsg4"
                 style="font-size:15px;color:#ff9966;font-weight:bold;">
                距离{{gkYear3}}年高考还有 <span style="color:blue;font-size:20px;">{{days4}} </span>天
                </div>
            </div>
            <div class="header-user" v-if="isShowGKMsg1" style="margin-left: 199px;">
                <el-form :model="ruleForm" :inline="true" style="width:100%;margin-left:0;" size="mini"
                  v-if="userInfo.yhlb === 7||userInfo.yhlb===9">
                    <el-form-item label="首选科目:" prop="sxkm">
                      <el-select style="width:100px" v-model="ruleForm.sxkm" @change="changeSxkm">
                        <el-option label="历史" value="1"></el-option>
                        <el-option label="物理" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="切换类别:"  prop="zylb">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <el-form :model="ruleForm" style="width:100%;margin-left:0;" size="mini"
                  v-else-if="userInfo.yhlb === 2&&userInfo.zylb.indexOf('音乐')>=0">
                    <el-form-item label="切换类别:"  prop="zylb" style="width: 54%;">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeYhZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in yhZylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <div style="width: 368px;">
                  您的成绩：
                <span>文化分 <strong class="score">{{ userInfo.wscore }}</strong>  分</span>
                <span> 专业分 <strong class="score">{{ userInfo.zscore }}</strong>  分</span>
                <span> 综合分 <strong class="score">{{ totalScore }}</strong>  分</span>
                </div>
              </div>
            <div class="header-user" v-else-if="isShowGKMsg2" style="margin-left: 129px;">
                <el-form :model="ruleForm" :inline="true" style="width:100%;margin-left:0;" size="mini"
                  v-if="userInfo.yhlb === 7||userInfo.yhlb===9">
                    <el-form-item label="首选科目:" prop="sxkm">
                      <el-select style="width:100px" v-model="ruleForm.sxkm" @change="changeSxkm">
                        <el-option label="历史" value="1"></el-option>
                        <el-option label="物理" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="切换类别:"  prop="zylb">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <el-form :model="ruleForm" style="width:100%;margin-left:0;" size="mini"
                  v-else-if="userInfo.yhlb === 2&&userInfo.zylb.indexOf('音乐')>=0">
                    <el-form-item label="切换类别:"  prop="zylb" style="width: 54%;">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeYhZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in yhZylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <div style="width: 368px;">
                  您的成绩：
                <span>文化分 <strong class="score">{{ userInfo.wscore }}</strong>  分</span>
                <span> 专业分 <strong class="score">{{ userInfo.zscore }}</strong>  分</span>
                <span> 综合分 <strong class="score">{{ totalScore }}</strong>  分</span>
                </div>
              </div>
            <div class="header-user" v-else-if="isShowGKMsg4" style="margin-left: 179px;">
                <el-form :model="ruleForm" :inline="true" style="width:100%;margin-left:0;" size="mini"
                  v-if="userInfo.yhlb === 7||userInfo.yhlb===9">
                    <el-form-item label="首选科目:" prop="sxkm">
                      <el-select style="width:100px" v-model="ruleForm.sxkm" @change="changeSxkm">
                        <el-option label="历史" value="1"></el-option>
                        <el-option label="物理" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="切换类别:"  prop="zylb">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <el-form :model="ruleForm" style="width:100%;margin-left:0;" size="mini"
                  v-else-if="userInfo.yhlb === 2&&userInfo.zylb.indexOf('音乐')>=0">
                    <el-form-item label="切换类别:"  prop="zylb" style="width: 54%;">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeYhZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in yhZylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <div style="width: 368px;">
                  您的成绩：
                <span>文化分 <strong class="score">{{ userInfo.wscore }}</strong>  分</span>
                <span> 专业分 <strong class="score">{{ userInfo.zscore }}</strong>  分</span>
                <span> 综合分 <strong class="score">{{ totalScore }}</strong>  分</span>
                </div>
              </div>
            <!-- <div class="header-user" v-if="userInfo.yhlb === 2" style="margin-left: 199px;">
                <el-form :model="ruleForm" :inline="true" style="width:100%;margin-left:0;" size="mini"
                  v-if="userInfo.yhlb === 7||userInfo.yhlb===9">
                    <el-form-item label="首选科目:" prop="sxkm">
                      <el-select style="width:100px" v-model="ruleForm.sxkm" @change="changeSxkm">
                        <el-option label="历史" value="1"></el-option>
                        <el-option label="物理" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="切换类别:"  prop="zylb">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <el-form :model="ruleForm" style="width:100%;margin-left:0;" size="mini"
                  v-else-if="userInfo.yhlb === 2&&userInfo.zylb.indexOf('音乐')>=0">
                    <el-form-item label="切换类别:"  prop="zylb" style="width: 54%;">
                      <el-select style="width:150px" v-model="ruleForm.zylb" @change="changeYhZy">
                        <el-option :label="item" :value="item" v-for="(item,index) in yhZylbOptions" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                </el-form>
                <div style="width: 360px;">
                  您的成绩：
                <span>文化分 <strong class="score">{{ userInfo.wscore }}</strong>  分</span>
                <span>专业分 <strong class="score">{{ userInfo.zscore }}</strong>  分</span>
                <span>综合分 <strong class="score">{{ totalScore }}</strong>  分</span>
                </div>
              </div> -->
            <div class="header-bottom">
                <!-- <el-select v-model="provinceId" style="width:100px;" size="small"></el-select> -->
                <!-- <el-button type="primary" size="small" style="margin-left:15px;">登录</el-button> -->
                <el-button type="primary" size="small" @click="loginOutCode">退出</el-button>
            </div>
            </div>
            <div class="header-nav">
                <!-- <ul class="nav-item">
                    <li :class="{current: $route.path.includes('/main/home')}"><router-link  to="/main/home" >首页</router-link></li>
                    <li :class="{current: $route.path.includes('/schoolRecommend')}"><router-link to="/schoolRecommend" >智能推荐</router-link></li>
                    <li :class="{current: $route.path.includes('/schoolfinder')}"><router-link to="/schoolfinder">院校查询 </router-link></li>
                    <li :class="{current: $route.path.includes('/majorquery')}"><router-link to="/majorquery">专业查询</router-link></li>
                    <li :class="{current: $route.path.includes('/datahome')}"><router-link to="/datahome">数据中心</router-link></li>
                    <li :class="{current: $route.path.includes('/me')}"><router-link to="/me">用户中心</router-link></li>
                    <li :class="{current: $route.path.includes('/buyCard')}" ><router-link to="/buyCard" >在线购买</router-link></li>
                    <li :class="{current: $route.path.includes('/register')}"><router-link to="/register"><i class="el-icon-s-custom"></i> 会员注册</router-link></li>
                    <li><a href="https://jbt.zy1dt.com" target="_blank"><i class="el-icon-s-promotion"></i>文化生系统入口</a></li>
                </ul> -->
                <ul class="nav-item">
                    <li :class="{current: $route.path.includes('/main/home')}">
                        <router-link to="/main/home">首页</router-link>
                    </li>
                    <li>
                     <a href="http://ceping.zy1dt.com/ceping/list.jhtml" target="_blank">测评工具</a>
                    </li>
                    <li :class="{current: $route.path.includes('/main/yshSchoolRecommend')}">
                        <router-link to="/main/yshSchoolRecommend">志愿推荐</router-link>
                    </li>
                    <!--  @mouseenter="clickShowJianKongYuTiaoZheng" @mouseleave="clickShowJianKongYuTiaoZheng2" -->
                    <li :class="{current: $route.path.includes('/main/yshSchoolFinder')}">
                        <router-link to="/main/yshSchoolFinder">院校查询</router-link>
                        <!-- <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowJKYTZ" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/schoolRecommend')}">
                                <router-link to="/main/schoolRecommend">院校推荐</router-link>
                            </li>
                        </ul> -->
                    </li>
                    <li :class="{current: $route.path.includes('/main/yshMajorQuery')}">
                        <router-link to="/main/yshMajorQuery">专业查询</router-link>
                    </li>
                    <li :class="{current: $route.path.includes('/main/yshDataHome')}">
                        <router-link to="/main/yshDataHome">数据查询</router-link>
                    </li>
                    <li :class="{current: $route.path.includes('/main/yshMe')}">
                        <router-link to="/main/yshMe">用户中心</router-link>
                    </li>
                    <li :class="{current: $route.path.includes('/main/buyindex')}">
                        <router-link to="/main/buyindex" >在线购买</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
// icon="el-icon-search"
import {mapState} from 'vuex';
// import {updateKL,getZyTypes,updateZylb} from "../api/index";
export default {
data(){
    return{
        searchContent:"",
        provinceId:"43",
        isShowQDMB:false,
        isShowZDJH:false,
        isShowSSFA:false,
        isShowJKYTZ:false,
        gkYear:"",
        days:"",
        isShowGKMsg1:false,
        gkYear2:"",
        gkYear3:"",
        days2:"",
        isShowGKMsg2:false,
        days3:"",
        days4:"",
        isShowGKMsg3:false,
        isShowGKMsg4:false,
        hours:"",
        minutes:"",
        second:"",
        gkTimer:null,
        ruleForm:{
            sxkm:'',
            zylb:''
        },
        module:{},
        zylbOptions:[],
        yhZylbOptions:[]
    };
},
methods:{
    refreshHtml(){
                let href="";
        if (location.href.indexOf("#") !== -1) {
            href = location.href.substring(0, location.href.indexOf("#"));
        }
        location.href =href;
    },
    clearYxcx(){},
    clearYxtj(){},
        clickShowErji(){
        this.isShowQDMB=true;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
        this.isShowJKYTZ=false;
    },
    clickShowErji2(){
        this.isShowQDMB=false;
    },
    clickShowZhiDingJiHua(){
        this.isShowZDJH=true;
        this.isShowQDMB=false;
        this.isShowSSFA=false;
        this.isShowJKYTZ=false;
    },
    clickShowZhiDingJiHua2(){
        this.isShowZDJH=false;
    },
    clickShowShiShiFangAn(){
        this.isShowSSFA=true;
        this.isShowQDMB=false;
        this.isShowZDJH=false;
        this.isShowJKYTZ=false;
    },
    clickShowShiShiFangAn2(){
        this.isShowSSFA=false;
    },
    clickShowJianKongYuTiaoZheng(){
        this.isShowJKYTZ=true;
        this.isShowQDMB=false;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
    },
    clickShowJianKongYuTiaoZheng2(){
        this.isShowJKYTZ=false;
    },
    // 改变首选科目
    async changeSxkm(sxkm){
      const res=await this.$http.getHttp("/users/updateKl?kl="+sxkm);
        if(res.data.code===200){
            await this.getUserInfo();
            this.$store.dispatch("RestSchoolData");
            this.$emit("reloadZypg",'true');
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
        // 获取用户信息
    async getUserInfo(){
        const res=await this.$http.getHttp("/users/getUserInfo?username="+this.userInfo.username);
        if(res.status===200){
            if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else{
                this.$store.dispatch("saveUserInfo",res.data);
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 改变专业类别
    async changeZy(lb){
      const zylbs = await this.$http.getHttp("/users/updateLB?lb="+lb);
      if(zylbs.data.code === 200){
        await this.getUserInfo();
        this.$store.dispatch("RestSchoolData");
        // this.$store.commit("initCollectSchool");
        this._totalScore(lb);
        if(this.$store.state.collectSchool&&this.$store.state.collectSchool.records&&this.$store.state.collectSchool.records.length>0){
            this.$store.dispatch("removeCollegeAll",{
                uid:this.$store.state.userInfo.yhid,
                callback:()=>{
                    console.log("删除收藏的院校成功");
                }
            });
        }
        this.$emit("yshReadLoad",'true');
      }else if(zylbs.data.code===500){
            if(zylbs.data.message){
                this.$message({message:zylbs.data.message,type:'error'});
            }else if(zylbs.data.msg){
                this.$message({message:zylbs.data.msg,type:"error"});
            }
      }else if(zylbs.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else{
        this.$message({type:'error',message:'修改失败',duration:'2000'})
      }  
    },
    
    // 改变专业类别
    async changeYhZy(lb){
      const zylbs = await this.$http.getHttp("/users/updateLB?lb="+lb);
      if(zylbs.data.code === 200){
        await this.getUserInfo();
        this.$store.dispatch("RestSchoolData");
        this._totalScore(lb);
      }else if(zylbs.data.code===500){
            if(zylbs.data.message){
                this.$message({message:zylbs.data.message,type:'error'});
            }else if(zylbs.data.msg){
                this.$message({message:zylbs.data.msg,type:"error"});
            }
      }else if(zylbs.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else{
        this.$message({type:'error',message:'修改失败',duration:'2000'})
      }
    },
        //动态计算当年综合分
    _totalScore(lb){
      //编导，播音与主持，摄影摄像
      let totalScore = 0;
      if(lb == '播音与主持类' ){
        totalScore = Number(this.userInfo.wscore)+Number(this.userInfo.zscore);
        this.$store.dispatch('saveTatalScore',totalScore);
      }else{
        totalScore = ((this.userInfo.wscore * 0.3) +(this.userInfo.zscore * 0.7)).toFixed(1);
        this.$store.dispatch('saveTatalScore',totalScore);
      }
      // if(lb == '编导类' || lb == '播音与主持艺术类' || lb == '摄影摄像类'){
      //   totalScore = Number(this.userInfo.wscore)+Number(this.userInfo.zscore);
      //   this.$store.dispatch('saveTatalScore',totalScore);
      // }else{
      //   totalScore = ((this.userInfo.wscore * 0.3) +(this.userInfo.zscore * 0.7)).toFixed(1);
      //   this.$store.dispatch('saveTatalScore',totalScore);
      // }
    },
    //初始化专业选项
   async _initZylb(){
      let zyResult=await this.module.getZyTypes();
    //   let zyResult = await getZyTypes();
      if(zyResult.data.code === 200){
        this.zylbOptions = zyResult.data.data;
      }
    },
    setGkTimer(){
        this.gkTimer=setInterval(() => {
        const currentYear=new Date().getFullYear();
        const gaokaoDate=new Date(currentYear,5,7);
        const tianbaoDate=new Date(currentYear,5,26);
        const editSchoolDate=new Date(currentYear,6,1);
        if(new Date()<gaokaoDate){
            this.isShowGKMsg1=true;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear=gaokaoDate.getFullYear();
            // gaokaoDate.setFullYear(currentYear+1);
        }else if(new Date()>=gaokaoDate&&new Date()<=tianbaoDate){   
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=true;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear2=currentYear;
        }else if(new Date()>tianbaoDate&&new Date()<=editSchoolDate){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&new Date().getMonth()==6
        &&new Date().getDate()==1){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            console.log(editSchoolDate);
            console.log(dqDate);
            console.log(chaDays);
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&(new Date().getMonth()>6
        ||(new Date().getMonth()==6
        &&new Date().getDate()>1))){
            gaokaoDate.setFullYear(currentYear+1);
            this.gkYear3=currentYear+1;
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=true;
            this.days4=Math.ceil((Math.abs(new Date()-gaokaoDate))/(1000*60*60*24));
        }
        const now=new Date();
        const cha=gaokaoDate-now;
        const cha2=tianbaoDate-now;
        if(cha>=0){
            this.days=Math.ceil(cha/(1000*60*60*24));
            // this.hours=Math.floor(cha%(1000*60*60*24)/(1000*60*60));
            // this.minutes=Math.floor(cha%(1000*60*60)/(1000*60));
            // this.second=Math.floor(cha%(1000*60)/1000);
        }else if(cha2>=0){
            this.days2=Math.ceil(cha2/(1000*60*60*24));
        }
    }, 1000);
    },
    async getApiIndexMethod(){
        const flag=this.$apiFlag;
        if(flag===1||flag===3){
            this.module=await import("../api/index");
        }else if(flag===2){
            this.module=await import("../api/index22");
        }
    },
    async getMusicZylb(){
        const res=await this.$http.getHttp("/getYylType");
        console.log(res);
        if(res.data.code===200){
            this.yhZylbOptions=res.data.data;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error",showClose:true});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error",showClose:true});
            }
        }
    },
    clickShowZhiYeCePing(){},
    clickShowZhiYeCePing2(){},
    loginOutCode(){
    this.$confirm('确认退出登录吗？', '提示',{type: 'warning'}).then(async(action) => {
          if(action === 'confirm'){
            const sjhm=this.userInfo.sjhm;
            await this.$store.dispatch('loginOut',{sjhm});
             this.$router.push('/main/home');
          }
        }).catch((error) => {
          return error;
        });
    }
},
computed:{
    ...mapState(["userInfo","totalScore"])
},
async mounted(){
    await this.getApiIndexMethod();
    this.setGkTimer();
    if(this.userInfo.yhlb===7||this.userInfo.yhlb===9){
        await this._initZylb();
    }else if(this.userInfo.yhlb===2){
        await this.getMusicZylb();
    }
    this._totalScore(this.userInfo.zylb);
    const sxkm=this.userInfo.sxkm;
    const zylb=this.userInfo.zylb;
    if(sxkm>0){
        this.ruleForm.sxkm=sxkm+"";
    }
    if(zylb){
        this.ruleForm.zylb=zylb;
    }
},
beforeDestroy(){
    clearInterval(this.gkTimer);
}
};
</script>
<style scoped lang="less">
.header-container{
    .header-top{
        display:flex;
        justify-content:space-between;
        align-items:center;
        width:1200px;
        height:130px;
        margin:0 auto;
        position:relative;
        .header-user{
            flex: 1;
            margin-right: 20px;
            text-align: right;
            font-size: 14px;
        }
        .score{
            color:#f56c6c;
        }
    }
    .header-md{
        flex:1;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        .md-change{
            flex: 1;
            // margin-left: 65px;
            margin-left:20px;
            padding-top: 12px;
            box-sizing: border-box;
        }
        .header-user{
            flex: 1;
            margin-right: 10px;
            text-align: right;
            font-size: 14px;
        }
        .score{
            color:#f56c6c;
        }
    }
    .header-rt{
        width: 160px;
        text-align: left;
    }
    .header-nav{
        width:100%;
        height:40px;
        background-color:#409EFF;
        .nav-item{
            max-width:1200px;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-flow:nowrap;
            color:#ffffff;
            li{
                flex-basis: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
        .nav-item2{
            // min-width:1200px;
            position: absolute;
            color:#ffffff;
            z-index: 9999;
            li{
                width: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                background-color:#409EFF;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
    }
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
</style>
